import COS from 'cos-js-sdk-v5';
import {sys} from "@/api/sys";

/**
 * 手动生成 uuid
 * @returns {string}
 */
function generateUUID() {
    const s4 = () => {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
}

/**
 * 生成唯一标识符
 * @returns {string}
 */
function generateUniqueIdentifier() {
    return Date.now() + '-' + generateUUID();
}

/**
 * 存储桶临时文件夹
 * @type {string}
 */
const COS_TEMP_KEY = "tmp/";

function generateRandomFileName(originalName) {
    // 获取文件后缀名
    const extension = originalName.substring(originalName.lastIndexOf('.'));

    // 获取当前时间戳
    const timestamp = Date.now();

    // 生成随机字符串
    const randomString = Math.random().toString(36).substr(2, 6);

    // 拼接新的文件名
    return `${timestamp}-${randomString}${extension}`;
}

export const tencentCos = {
    upload(file) {
        return new Promise((resolve, reject) => {
            sys.getTencentCosTempKey().then(res => {
                let cosConfig = res.data;

                // noinspection JSCheckFunctionSignatures,JSUnresolvedReference
                let cos = new COS({
                    SecretId: cosConfig.tmpSecretId,
                    SecretKey: cosConfig.tmpSecretKey,
                    SecurityToken: cosConfig.sessionToken,
                    StartTime: cosConfig.startTime,
                    ExpiredTime: cosConfig.expiredTime,
                    ScopeLimit: true,
                });

                // 从文件路径中提取文件名
                let filename = file.name;

                filename = generateRandomFileName(filename);

                // 生成唯一标识符并与文件名组合，生成新的文件名
                let generateFilenameNew = generateUniqueIdentifier() + '-' + filename;

                cos.uploadFile({
                        Bucket: cosConfig.bucket, // 填写自己的 bucket，必须字段
                        Region: cosConfig.region,     // 存储桶所在地域，必须字段
                        Key: COS_TEMP_KEY + generateFilenameNew,            // 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段
                        Body: file, // 上传文件对象
                        onProgress: function (progressData) {
                            console.log('上传进度：', progressData);
                        }
                    }, (err, data) => {
                        if (err) {
                            console.error(err);
                            reject(err);
                        } else {
                            let fileLocation = 'https://' + data.Location;
                            resolve(fileLocation);
                        }
                    }
                )

            })
        });


    },
}